<template>
  <div>
    <!-- BEGIN header item description -->
    <div
      @click="$emit('clickOnItem')"
      class="py-5 gap-x-4 gap-y-10 items-center place-content-center"
      :class="{
        'hover:bg-indigo-200': !disabled,
        'cursor-not-allowed': disabled,
        'bg-indigo-200 border-l-2 border-indigo-600': isAccordionDisplayed,
        [`grid ${grid}`]: true,
        heightLine: true,
      }"
    >
      <slot name="description" />
    </div>
    <!-- END header item description -->
    <transition
      enter-active-class="ease-out duration-300"
      enter-class="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
      enter-to-class="opacity-100 translate-y-0 sm:scale-100"
      leave-active-class="ease-in duration-200"
      leave-class="opacity-100 translate-y-0 sm:scale-100"
      leave-to-class="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
    >
      <div
        v-show="isAccordionDisplayed"
        class="bg-white px-10 py-5"
      >
        <slot name="content" />
      </div>
    </transition>
  </div>
</template>

<script>
export default {
  props: {
    disabled: {
      type: Boolean,
      required: false,
      default: false
    },

    isAccordionDisplayed: {
      type: Boolean,
      required: false,
      default: false,
    },

    grid: {
      type: String,
      required: false,
      default: 'grid-cols-12',
    },
    heightLine: {
      type: String,
      required: false,
      default: 'h-16 lg:h-24 2xl:h-32',
    },
  },
};
</script>
